import React, { useMemo, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Constants, helpers, Enums } from "@shared";
import currency from "currency.js";
import { useForm, validators } from "@hooks";
import classNames from "classnames";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { v4 as uuidv4 } from 'uuid';

const MakePayment = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const {
        state: {
            currentBill,
            account: { idPayor, paymentPreferences: { defaultPaymentMethod } }
        }
    } = location;

    const { dueDate, invitations } = currentBill;
    const month = helpers.monthName(dueDate);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const submit = () => {
        const amount = currency(values.amount).value;
        helpers.navigateNext(location, navigate, { amount }, {
            amount,
            idempotencyKey: uuidv4()
        });
    };

    const total = useMemo(() => {
        const invitation = invitations.find(i => i.idPayor === idPayor);
        return currency(invitation.balance);
    }, [currentBill]);


    const initialState = { amount: `` };
    const validations = {
        amount: (val) => {
            const amount = currency(val);
            if (total.subtract(amount).intValue !== 0 && total.subtract(amount).value < currency(Constants.System.MIN_PAYMENT_AMOUNT).value && amount.value < total.value)
                return { amount: `Amount not valid. Remaining balance must be greater than ${currency(Constants.System.MIN_PAYMENT_AMOUNT).format()}` };

            return validators.hasAmount(val) && amount.value >= currency(Constants.System.MIN_PAYMENT_AMOUNT).value && amount.value <= total.value || { amount: `Amount not valid` };
        }
    };
    const { values, errors, changeHandler, submitHandler } = useForm(initialState, {}, validations, submit);

    const accounType = defaultPaymentMethod.idPaymenttype === Enums.PaymentType.ACH ? defaultPaymentMethod.accounType : ``;

    return (
        <form method="POST" onSubmit={submitHandler} >
            <div className="flex flex-col bg-white p-6 w-full rounded-b-lg min-h-sb pb-12 items-center gap-y-4">
                <h1 className="text-center font-bold text-2xl">{`${month} Balance`}</h1>
                <div className="flex flex-col items-left p-5 rounded-lg border-2 shadow-md gap-y-4 bg-sb-frame w-full">
                    <h1 className="text-center font-semibold text-4xl">{total.format()}</h1>
                    <div className="w-72 mx-auto ">
                        <div className="relative rounded-md shadow-sm">
                            <input
                                type="text"
                                name="amount"
                                id="amount"
                                className={classNames(`block w-72 rounded-md shadow-md focus:outline-none text-gray-500 text-3xl text-center py-3 placeholder:font-normal placeholder:text-2xl px-12`, { "input-error": errors.amount })}
                                value={values.amount}
                                onChange={changeHandler}
                                placeholder="Input amount"
                                aria-invalid="true" />
                            {
                                errors.amount &&
                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                    <ExclamationCircleIcon className="fill-red-500 h-8" />
                                </div>
                            }
                        </div>
                        {
                            errors.amount &&
                            <span className="mt-2 text-sm text-red-600" id="email-error">{errors.amount}</span>
                        }
                    </div>
                    <div className="w-full text-lg">
                        <span className="text-gray-500">Enter an amount between {currency(Constants.System.MIN_PAYMENT_AMOUNT).format()} and {total.format()}</span>
                    </div>

                    <div className="w-full text-lg">
                        <span className="font-bold">Payment Method: </span>
                        <span>{defaultPaymentMethod.sourceName}</span>
                        <span>{`${accounType} ****${defaultPaymentMethod.last4}`}</span>
                    </div>
                    <button type="submit" className="btn btn-primary font-bold rounded-full my-4">Continue</button>
                </div>

            </div>
        </form>
    );
};

export default MakePayment;